/** sessionStorage — Notifications → Expenses dashboard deep-link */
export const PENDING_EXPENSE_OPEN_KEY = 'pendingExpensesOpen_expenseId';

/** sessionStorage — Notifications → Accounting dashboard tab (reuses integrity lab shape) */
export const NOTIFICATION_ACCOUNTING_NAV_KEY = 'erp_integrity_lab_nav';
